import { GTMEventCategories } from '@mafc/common';
import APP_CONFIG, { EStoreID } from 'config/App.config';
import { GTMEvents } from 'constants/gtm.constants';
import { getJourneySelectionParams } from './gtm.utils';
import { getHashed256Email } from './cookies.util';

const { currency: currencyCode, storeId } = APP_CONFIG;
declare var dataLayer: any;

abstract class TrackerCheckout {
  static journeySelectionParams = getJourneySelectionParams();

  static purchaseEvent = ({
    id,
    revenue,
    coupon,
    products,
    shipmentCount,
    shipmentCategory,
    shipmentType,
    substitution,
    shipping,
    eventData,
    paymentMode,
    isNewUser,
  }: any) => {
    dataLayer.push({
      module_name: 'c4_main',
      event: GTMEvents.purchase,
      event_action: GTMEvents.purchase,
      event_category: GTMEventCategories.enhanced_ecommerce,
      event_label: id + '_' + revenue,
      transaction_id: id,
      value: revenue,
      coupon,
      items: products,
      screen_type: 'order_confirmation',
      screen_name: 'order_confirmation',
      ga4: 'true',
      currency: storeId === EStoreID.MAFLBN && currencyCode === 'USD' ? 'LBP' : currencyCode,
      shipments_count: shipmentCount,
      payment_type: paymentMode,
      is_first_purchase: !!isNewUser ? 'true' : 'false',
      hashed_email_sha256: getHashed256Email(),
      shipments_category: shipmentCategory,
      shipments_type: shipmentType,
      shipping,
      substitution,
      ...eventData,
      ...TrackerCheckout.journeySelectionParams,
    });
  };
}

export default TrackerCheckout;
